module.exports = __webpack_public_path__ + "images/company_profile/icon_en03-47c37af9ad017a9cbc7b6487a3ed38b6.png";